/** @internal */ let header = ""
/** @internal */ let glsl = ""

/** @internal */ export function shaderLib() {
	return glsl
}

/** @internal */ export function shaderLibHeader() {
	return header
}


header += `#define pi 3.141592653589793238462643383279
float cosinus(float x) {return cos(x);} // TODO make a custom implementation as the default isn't reliable
float sinus(float x) {return sin(x);} // TODO make a custom implementation as the default isn't reliable
`

header += `vec2 uv2equatorial(vec2 uv);vec2 uv2hammer(vec2 uv);vec2 uv2sphere(vec2 uv);`
glsl += `
// where uv ranges from -1 to 1
vec2 uv2equatorial(vec2 uv) {
	return uv*vec2(pi,.5*pi);
}
vec2 uv2hammer(vec2 uv) {
	vec2 pos = uv*vec2(pi,.5*pi);
	#ifdef FRAGMENT_SHADER
	if(length(vec2(pos.x,pos.y*2.)) > pi) { discard; }
	#endif
	return hammer2spheric(pos);
}
vec2 uv2sphere(vec2 uv) {
	vec2 pos = uv;
	#ifdef FRAGMENT_SHADER
	if(length(vec2(pos.x,pos.y)) > 1.) { discard; }
	#endif
	return vec2(-acos(pos.x/cos(asin(pos.y)))+pi/2.,asin(pos.y));
}
`

header += `
 vec4 texture1d( sampler2D tex, int index, int lod); vec4 texture1d( sampler2D tex, int index);
ivec4 texture1d(isampler2D tex, int index, int lod);ivec4 texture1d(isampler2D tex, int index);
uvec4 texture1d(usampler2D tex, int index, int lod);uvec4 texture1d(usampler2D tex, int index);
`

glsl += `
// isampler3D,usampler3D
// sampler2DArray,isampler2DArray,usampler2DArray
// samplerCube,isamplerCube,usamplerCube
// sampler2DArrayShadow,samplerCubeShadow,sampler2DShadow
vec4 texture1d(sampler2D tex, int index, int lod) {
	ivec2 size = textureSize(tex, lod);
	int i = index % size.x;
	int j = index / size.x;
	return texelFetch(tex, ivec2(i, j), lod);
}
vec4 texture1d(sampler2D tex, int index) { return texture1d(tex, index, 0); }
ivec4 texture1d(isampler2D tex, int index, int lod) {
	ivec2 size = textureSize(tex, lod);
	int i = index % size.x;
	int j = index / size.x;
	return texelFetch(tex, ivec2(i, j), lod);
}
ivec4 texture1d(isampler2D tex, int index) { return texture1d(tex, index, 0); }
uvec4 texture1d(usampler2D tex, int index, int lod) {
	ivec2 size = textureSize(tex, lod);
	int i = index % size.x;
	int j = index / size.x;
	return texelFetch(tex, ivec2(i, j), lod);
}
uvec4 texture1d(usampler2D tex, int index) { return texture1d(tex, index, 0); }
`

// let hammer2spheric = (hammer) => {
// 	let lonlat = [0,0];

// 	// hammer.x = 0.5 * hammer.x;
// 	hammer[0] = 0.5 * hammer[0]*2./π;
// 	hammer[1] = 0.5 * hammer[1]*2./π*2.;

// 	let s = (hammer[0] * hammer[0]) + (hammer[1] * hammer[1]);
// 	s = Math.sqrt(2.0 - s);
// 	lonlat[1] =    Math.asin( hammer[1] * s);

// 	// TODO : floating precision problem with this division
// 	lonlat[0] = 2.*Math.asin((hammer[0] * s) / Math.cos(lonlat[1] ));

// 	return lonlat;
// }

// let spheric2hammer = (lonlat) => {
// 	lonlat[0] = lonlat[0] - π;

// 	let cosLat = Math.cos(lonlat[1]);
// 	let halfLon = 0.5 * lonlat[0];
// 	let s = Math.sqrt(1.0 + (cosLat * Math.cos(halfLon)));

// 	let hammer = [0,0];
// 	hammer[0] = (2.0 * cosLat * Math.sin(halfLon)) / s;
// 	hammer[1] = Math.sin(lonlat[1]) / s;

// 	// rescale xy
// 	hammer[0] *= π*0.5;
// 	hammer[1] *= π*0.5;

// 	return hammer;
// }

// let θφ2φθ = (θφ) => [θφ[1],θφ[0]]

// let spheric_rotation = (phitheta, rot) => {
// 	let vector = v3.create(
// 		Math.cos(phitheta[1])*Math.cos(phitheta[0]),
// 		Math.cos(phitheta[1])*Math.sin(phitheta[0]),
// 		Math.sin(phitheta[1])
// 	);

// 	vector = m4.transformPoint(rot,vector);
// 	// those next lines should usually not happen...
// 	// vector.xyz /= vector.w;
// 	// vector.w = 1.;

// 	// phitheta[0] = Math.atan(vector[1],vector[0])+π;
// 	// phitheta[1] = Math.atan(Math.sqrt(vector[0]*vector[0] + vector[1]*vector[1]),vector[2]) - π*.5;
// 	phitheta[0] = Math.atan(vector[1],vector[0]);
// 	phitheta[1] = Math.atan(Math.sqrt(vector[0]*vector[0] + vector[1]*vector[1]),vector[2]) - π/4;

// 	return phitheta;
// }

// let spheric2vec = (lonlat) => {
// 	return v3.create(
// 		Math.cos(lonlat[1])*Math.cos(lonlat[0]),
// 		Math.cos(lonlat[1])*Math.sin(lonlat[0]),
// 		Math.sin(lonlat[1])
// 	);
// }


header += `vec2 spheric2hammer(vec2 lonlat);
vec2 spheric2hammer(float lon, float lat);
vec2 hammer2spheric(vec2 hammer);
vec2 hammer2spheric(float x, float y);
vec3 spheric2vec(vec2 lonlat);
vec3 spheric2vec(float lon, float lat);
vec2 vec2spheric(vec3 vec);
vec2 vec2spheric(vec4 vec);
vec2 vec2spheric(float x,float y,float z);
vec2 spheric_rotation(vec2 phitheta, mat4 rot);
float gridBackground(vec2 p);
float gridBackgroundSpheric(vec2 p);
float gridBackgroundSpheric(vec2 p, float thickness);
// cf aladin source code
// TODO : transposed ?
const mat3 J2000_TO_GALACTIC = mat3(
	-0.0548755604024359, -0.8734370902479237,-0.4838350155267381,
	 0.4941094279435681, -0.4448296299195045, 0.7469822444763707,
	-0.8676661489811610, -0.1980763734646737, 0.4559837762325372
);
const mat3 GALACTIC_TO_J2000 = transpose(J2000_TO_GALACTIC);
`

glsl += `
vec2 spheric2hammer(vec2 lonlat) {
	lonlat.x = lonlat.x - pi;

	float cosLat = cosinus(lonlat.y);
	float halfLon = 0.5 * lonlat.x;
	float s = sqrt(1.0 + (cosLat * cosinus(halfLon)));

	vec2 hammer;
	hammer.x = (2.0 * cosLat * sinus(halfLon)) / s;
	hammer.y = sinus(lonlat.y) / s;

	// rescale xy
	hammer.x *= pi*0.5;
	hammer.y *= pi*0.5;

	return hammer;
}
vec2 spheric2hammer(float lon, float lat) {
	return spheric2hammer(vec2(lon,lat));
}

vec2 hammer2spheric(vec2 hammer) {
	vec2 lonlat;

	// hammer.x = 0.5 * hammer.x;
	hammer.x = 0.5 * hammer.x*2./pi;
	hammer.y = 0.5 * hammer.y*2./pi*2.;

	float s = (hammer.x * hammer.x) + (hammer.y * hammer.y);
	s = sqrt(2.0 - s);
	lonlat.y =    asin( hammer.y * s);

	// TODO : floating precision problem with this division
	lonlat.x = 2.*asin((hammer.x * s) / cosinus(lonlat.y ));

	return lonlat;
}
vec2 hammer2spheric(float x, float y) {
	return hammer2spheric(vec2(x,y));
}

vec3 spheric2vec(vec2 lonlat) {
	return vec3(
		cosinus(lonlat.y)*cosinus(lonlat.x),
		cosinus(lonlat.y)*sinus(lonlat.x),
		sinus(lonlat.y)
	);
}
vec3 spheric2vec(float lon, float lat) {
	return spheric2vec(vec2(lon,lat));
}

vec2 vec2spheric(vec3 vec) {
	vec2 phitheta;
	phitheta.x = atan(vec.y,vec.x) + pi;
	phitheta.y = atan(sqrt(vec.x*vec.x + vec.y*vec.y),vec.z) - pi*.5;
	return phitheta;
}
vec2 vec2spheric(vec4 vec) {
	// the division by w is not necessary here
	return vec2spheric(vec.xyz);
}
vec2 vec2spheric(float x,float y,float z){
	return vec2spheric(vec3(x,y,z));
}

vec2 spheric_rotation(vec2 phitheta, mat4 rot) {
	// vec4 vec = vec4(
	// 	cos(phitheta.y+pi)*cos(phitheta.x),
	// 	cos(phitheta.y+pi)*sin(phitheta.x),
	// 	sin(phitheta.y+pi),
	// 	1.
	// );

	vec4 vec = vec4(spheric2vec(phitheta),1);

	vec = rot*vec;

	return vec2spheric(vec);
}

// /* this is an implicit function for a background grid */
// float gridBackground(vec2 p) {
// 	float f = 0.;
// 	float sub_thick = 50.;
// 	float sub;

// 	sub = 1.;
// 	f+=mod(p.x+sub/sub_thick/2.,sub)<sub/sub_thick?1.:0.;
// 	f+=mod(p.y+sub/sub_thick/2.,sub)<sub/sub_thick?1.:0.;
// 	sub = 0.1;
// 	f+=mod(p.x+sub/sub_thick/2.,sub)<sub/sub_thick?1.:0.;
// 	f+=mod(p.y+sub/sub_thick/2.,sub)<sub/sub_thick?1.:0.;
// 	return f;
// }

// float gridBackgroundSpheric(vec2 p, float thickness) {
// 	float f = 0.;
// 	float sub_thick = 1./50.;
// 	float sub;

// 	#ifdef FRAGMENT_SHADER
// 	// TODO : compute with dFdx and dFdy to have a constant width
// 	// return clamp(f/df,0.,1.);
// 	#endif

// //////////////////////////////////////////////////////////////////////////////////////
// 	// sub = pi/2.;
// 	// float s = 3.*thickness;
// 	// f+=mod(p.x+sub*sub_thick/s/2./cosinus(p.y),sub)<sub*sub_thick/s/cosinus(p.y)?1.:0.;
// 	// f+=mod(p.y+sub*sub_thick/s/2.             ,sub)<sub*sub_thick/s             ?1.:0.;

// 	// sub = sub/6.;
// 	// s = 1.*thickness;
// 	// f+=(mod(p.x+sub*sub_thick/s/2./cosinus(p.y),sub)<sub*sub_thick/s/cosinus(p.y)?1.:0.) * (abs(p.y)<5.*pi/12. ?1.:0.);
// 	// f+=(mod(p.y+sub*sub_thick/s/2.             ,sub)<sub*sub_thick/s                                           ?1.:0.);
// //////////////////////////////////////////////////////////////////////////////////////

// 	float c = cosinus(p.y);
// 	sub = pi/2.;
// 	f+=1.-sigmoid(20.*abs(mod(p.x+sub/2.,sub) - sub/2.)*thickness*c);
// 	f+=1.-sigmoid(20.*abs(mod(p.y+sub/2.,sub) - sub/2.)*thickness  );

// 	sub = sub/6.;
// 	if(abs(p.y)<5.*pi/12.+0.02/thickness) {
// 		f+=1.-sigmoid(40.*abs(mod(p.x+sub/2.,sub) - sub/2.)*thickness*c);
// 		f+=1.-sigmoid(40.*abs(mod(p.y+sub/2.,sub) - sub/2.)*thickness  );

// 		// if(abs(p.y)<5.*pi/12.+0.01/thickness) {
// 		// 	sub = sub/5.;
// 		// 	f+=1.-sigmoid(80.*abs(mod(p.x+sub/2.,sub) - sub/2.)*thickness*c);
// 		// 	f+=1.-sigmoid(80.*abs(mod(p.y+sub/2.,sub) - sub/2.)*thickness  );
// 		// }
// 	}

// //////////////////////////////////////////////////////////////////////////////////////
// 	// sub = sub/6.;
// 	// f+=mod(p.x+sub*sub_thick/2./cos(p.y),sub)<sub*sub_thick/cos(p.y)?1.:0.;
// 	// f+=mod(p.y+sub*sub_thick/2.         ,sub)<sub*sub_thick         ?1.:0.;

// 	// sub = sub/6.;
// 	// f+=mod(p.x+sub*sub_thick/2./cos(p.y),sub)<sub*sub_thick/cos(p.y)?1.:0.;
// 	// f+=mod(p.y+sub*sub_thick/2.         ,sub)<sub*sub_thick         ?1.:0.;

// 	// sub = sub/6.;
// 	// f+=mod(p.x+sub*sub_thick/2./cos(p.y),sub)<sub*sub_thick/cos(p.y)?1.:0.;
// 	// f+=mod(p.y+sub*sub_thick/2.         ,sub)<sub*sub_thick         ?1.:0.;
// 	return clamp(f,0.,1.);

// }

// float gridBackgroundSpheric(vec2 p) {
// 	return gridBackgroundSpheric(p,1.);
// }

`

	// LG.GLSL.js.spheric_rotation = (φθ, rot_mat) => {
	// 	// vec4 vector = vec4(
	// 	// 	cos(phitheta.y+pi)*cos(phitheta.x),
	// 	// 	cos(phitheta.y+pi)*sin(phitheta.x),
	// 	// 	sin(phitheta.y+pi),
	// 	// 	1.
	// 	// );
	// 	// vector = rot*vector;
	// 	// // those next lines should usually not happen...
	// 	// // vector.xyz /= vector.w;
	// 	// // vector.w = 1.;

	// 	// phitheta.x = atan(vector.y,vector.x) + pi;
	// 	// phitheta.y = atan(sqrt(vector.x*vector.x + vector.y*vector.y),vector.z) - pi*.5;

	// 	// return phitheta;

	// }

	// LG.GLSL.js.spheric2hammer = (lonlat) => {
	// 	// lonlat.x = lonlat.x - pi;

	// 	// float cosLat = cos(lonlat.y);
	// 	// float halfLon = 0.5 * lonlat.x;
	// 	// float s = sqrt(1.0 + (cosLat * cos(halfLon)));

	// 	// vec2 hammer;
	// 	// hammer.x = (2.0 * cosLat * sin(halfLon)) / s;
	// 	// hammer.y = sin(lonlat.y) / s;

	// 	// // rescale xy
	// 	// hammer.x *= pi*0.5;
	// 	// hammer.y *= pi*0.5;

	// 	// return hammer;
	// }

	// LG.GLSL.js.hammer2spheric = (hammer) => {
	// 	// vec2 lonlat;

	// 	// // hammer.x = 0.5 * hammer.x;
	// 	// hammer.x = 0.5 * hammer.x*2./pi;
	// 	// hammer.y = 0.5 * hammer.y*2./pi*2.;

	// 	// float s = (hammer.x * hammer.x) + (hammer.y * hammer.y);
	// 	// s = sqrt(2.0 - s);
	// 	// lonlat.y =    asin( hammer.y * s);

	// 	// // TODO : floating precision problem with this division
	// 	// lonlat.x = 2.*asin((hammer.x * s) / cos(lonlat.y ));

	// 	// return lonlat;
	// }

	// LG.GLSL.js.spheric2vec = (lon, lat) => {
	// 	return [
	// 		cos(lat) * cos(lon),
	// 		cos(lat) * sin(lon),
	// 		sin(lat)
	// 	]
	// }

// https://salsa.debian.org/debian-astro-team/chealpix/-/blob/master/chealpix.c
header += `vec2 pix2ang(int nside, int ipix);int ang2pix(int depth, vec2 phitheta);`

glsl += `
const int ctab[] = int[](
	0,1,256,257,2,3,258,259,512,513,768,769,514,515,770,771,4,5,260,261,6,7,262,
	263,516,517,772,773,518,519,774,775,1024,1025,1280,1281,1026,1027,1282,1283,
	1536,1537,1792,1793,1538,1539,1794,1795,1028,1029,1284,1285,1030,1031,1286,
	1287,1540,1541,1796,1797,1542,1543,1798,1799,8,9,264,265,10,11,266,267,520,
	521,776,777,522,523,778,779,12,13,268,269,14,15,270,271,524,525,780,781,526,
	527,782,783,1032,1033,1288,1289,1034,1035,1290,1291,1544,1545,1800,1801,1546,
	1547,1802,1803,1036,1037,1292,1293,1038,1039,1294,1295,1548,1549,1804,1805,
	1550,1551,1806,1807,2048,2049,2304,2305,2050,2051,2306,2307,2560,2561,2816,
	2817,2562,2563,2818,2819,2052,2053,2308,2309,2054,2055,2310,2311,2564,2565,
	2820,2821,2566,2567,2822,2823,3072,3073,3328,3329,3074,3075,3330,3331,3584,
	3585,3840,3841,3586,3587,3842,3843,3076,3077,3332,3333,3078,3079,3334,3335,
	3588,3589,3844,3845,3590,3591,3846,3847,2056,2057,2312,2313,2058,2059,2314,
	2315,2568,2569,2824,2825,2570,2571,2826,2827,2060,2061,2316,2317,2062,2063,
	2318,2319,2572,2573,2828,2829,2574,2575,2830,2831,3080,3081,3336,3337,3082,
	3083,3338,3339,3592,3593,3848,3849,3594,3595,3850,3851,3084,3085,3340,3341,
	3086,3087,3342,3343,3596,3597,3852,3853,3598,3599,3854,3855
);

const int utab[] = int[](
	0,1,4,5,16,17,20,21,64,65,68,69,80,81,84,85,256,257,260,261,272,273,276,277,
	320,321,324,325,336,337,340,341,1024,1025,1028,1029,1040,1041,1044,1045,1088,
	1089,1092,1093,1104,1105,1108,1109,1280,1281,1284,1285,1296,1297,1300,1301,
	1344,1345,1348,1349,1360,1361,1364,1365,4096,4097,4100,4101,4112,4113,4116,
	4117,4160,4161,4164,4165,4176,4177,4180,4181,4352,4353,4356,4357,4368,4369,
	4372,4373,4416,4417,4420,4421,4432,4433,4436,4437,5120,5121,5124,5125,5136,
	5137,5140,5141,5184,5185,5188,5189,5200,5201,5204,5205,5376,5377,5380,5381,
	5392,5393,5396,5397,5440,5441,5444,5445,5456,5457,5460,5461,16384,16385,16388,
	16389,16400,16401,16404,16405,16448,16449,16452,16453,16464,16465,16468,16469,
	16640,16641,16644,16645,16656,16657,16660,16661,16704,16705,16708,16709,16720,
	16721,16724,16725,17408,17409,17412,17413,17424,17425,17428,17429,17472,17473,
	17476,17477,17488,17489,17492,17493,17664,17665,17668,17669,17680,17681,17684,
	17685,17728,17729,17732,17733,17744,17745,17748,17749,20480,20481,20484,20485,
	20496,20497,20500,20501,20544,20545,20548,20549,20560,20561,20564,20565,20736,
	20737,20740,20741,20752,20753,20756,20757,20800,20801,20804,20805,20816,20817,
	20820,20821,21504,21505,21508,21509,21520,21521,21524,21525,21568,21569,21572,
	21573,21584,21585,21588,21589,21760,21761,21764,21765,21776,21777,21780,21781,
	21824,21825,21828,21829,21840,21841,21844,21845
);

const int jrll[] = int[](2,2,2,2,3,3,3,3,4,4,4,4);
const int jpll[] = int[](1,3,5,7,0,2,4,6,1,3,5,7);

// int isqrt(int number) {
// 	return int(sqrt( float(number)+0.5));
// }
// int imodulo(int v1, int v2) {
// 	int v = v1%v2;
// 	return (v>=0) ? v : v+v2;
// }

/*! Returns the remainder of the division \a v1/v2.
		The result is non-negative.
		\a v1 can be positive or negative; \a v2 must be positive. */
float fmodulo(float v1, float v2) {
	if (v1>=0.0) return (v1<v2) ? v1 : mod(v1,v2);
	float tmp = mod(v1,v2)+v2;
	return (tmp==v2) ? 0.0 : tmp;
	// return (v1>=0) ? ((v1<v2) ? v1 : fmod(v1,v2)) : (fmod(v1,v2)+v2);
}

int xyf2nest(int nside, int ix, int iy, int face_num) {
	return (face_num*nside*nside) + (utab[ix&0xff] | (utab[ix>>8]<<16) | (utab[iy&0xff]<<1) | (utab[iy>>8]<<17));
}

int ang2pix_nest_z_phi(int nside, float z, float phi) {
	float za = abs(z);
	float tt = fmodulo(phi,2.0*pi) * 2.0/pi; // in [0,4)
	int face_num, ix, iy;

	if(za<=2./3.) { // Equatorial region
		float temp1 = float(nside)*(0.5+tt);
		float temp2 = float(nside)*(z*0.75);
		int jp = int(temp1-temp2); // index of  ascending edge line
		int jm = int(temp1+temp2); // index of descending edge line
		int ifp = jp/nside; // in {0,4}
		int ifm = jm/nside;
		if (ifp == ifm) // faces 4 to 7
			face_num = (ifp==4) ? 4: ifp+4;
		else if (ifp < ifm) // (half-)faces 0 to 3
			face_num = ifp;
		else // (half-)faces 8 to 11
			face_num = ifm + 8;

		ix = jm & (nside-1);
		iy = nside - (jp & (nside-1)) - 1;
	} else { // polar region, za > 2/3
		int ntt = int(tt);
		if (ntt>=4) ntt=3;
		float tp = tt-float(ntt);
		float tmp = float(nside)*sqrt(3.0*(1.0-za)); // problem here when "za" close to 1 (on poles)

		int jp = int(tp*tmp); // increasing edge line index
		int jm = int((1.0-tp)*tmp); // decreasing edge line index
		if (jp>=nside) jp = nside-1; // for points too close to the boundary
		if (jm>=nside) jm = nside-1;
		if (z >= 0.0) {
			face_num = ntt;  // in {0,3}
			ix = nside - jm - 1;
			iy = nside - jp - 1;
		} else {
			face_num = ntt + 8; // in {8,11}
			ix =  jp;
			iy =  jm;
		}
	}

	return xyf2nest(nside,ix,iy,face_num);

}

int ang2pix_nest(int nside, vec2 thetaphi) {
	// UTIL_ASSERT((θ>=0)&&(θ<=π),"θ out of range");
	// return ang2pix_nest_z_phi(nside,cos(thetaphi.x),thetaphi.y); // I believe the precsion problem comes from cos
	// float c = cos(thetaphi.x);
	float c = cosinus(thetaphi.x);
	return ang2pix_nest_z_phi(nside,c,thetaphi.y); // I believe the precsion problem comes from cos
}

ivec3 nest2xyf(int nside, int pix) {
	int npface = nside*nside;
	int face_num = pix / npface;
	pix &= npface - 1;
	int raw = (pix&0x5555) | ((pix&0x55550000)>>15);
	int ix = ctab[raw&0xff] | (ctab[raw>>8]<<4);
	pix >>= 1;
	raw = (pix&0x5555) | ((pix&0x55550000)>>15);
	int iy = ctab[raw&0xff] | (ctab[raw>>8]<<4);
	return ivec3(ix, iy, face_num); //[ix, iy, face_num];
}

vec2 pix2ang_nest_z_phi(int nside, int pix) {
	float z = 1.0;
	float phi = 1.0;

	int nl4 = nside*4;
	int npix=12*nside*nside;
	float fact2 = 4.0/float(npix);
	int nr;
	int kshift;

	ivec3 ixiyface_num = nest2xyf(nside, pix);
	int ix = int(ixiyface_num.x);
	int iy = int (ixiyface_num.y);
	int face_num = int(ixiyface_num.z);

	int jr = ( (jrll[face_num]*nside) - ix - iy - 1 );

	if ( jr < nside ) {
		nr = jr;
		z = 1.0 - float(nr*nr)*fact2;
		kshift = 0;
	} else if (jr > 3*nside) {
		nr = nl4-jr;
		z = float(nr*nr)*fact2 - 1.0;
		kshift = 0;
	} else {
		float fact1 = float(nside<<1)*fact2;
		nr = nside;
		z = float(2*nside-jr)*fact1;
		kshift = (jr-nside)&1;
	}

	int jp = ( (jpll[face_num]*nr + ix - iy + 1 + kshift) / 2);
	if ( jp > nl4 ) jp -= nl4;
	if ( jp < 1   ) jp += nl4;

	phi = ( float(jp) - float(kshift+1)*0.5 )*(pi*0.5/float(nr));

	return vec2(z,phi); //[z,φ];
}

vec2 pix2ang_nest(int nside, int ipix) {
	vec2 zphi = pix2ang_nest_z_phi (nside,ipix);
	float theta = acos(zphi.x); // acos(z);
	return vec2(theta,zphi.y);
}

// to gaia standard conversion
vec2 pix2ang(int nside, int ipix) {
	vec2 thetaphi = pix2ang_nest(nside, ipix);
	return (thetaphi + vec2(-pi/2.,0)).yx;
}
int ang2pix (int depth, vec2 phitheta) {
	return ang2pix_nest(1 << depth, vec2(phitheta.y + pi/2., phitheta.x));
}
`

header += `vec3 hsv2rgb(vec3 hsv);vec3 hsv2rgb(float h, float s, float v);vec3 hsv2rgb(float h);vec4 hsv2rgb(vec4 hsva);vec4 hsv2rgba(vec3 hsv);vec4 hsv2rgba(float h, float s, float v);vec4 hsv2rgba(float h);`
glsl += `
vec3 hsv2rgb(vec3 hsv) {
	vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
	vec3 p = abs(fract(hsv.xxx + K.xyz) * 6.0 - K.www);
	return hsv.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), hsv.y);
}
vec3 hsv2rgb(float h, float s, float v) {
	return hsv2rgb(vec3(h,s,v));
}
vec3 hsv2rgb(float h) {
	return hsv2rgb(h, 1., 1.);
}
vec4 hsv2rgb(vec4 hsva) {
	return vec4(hsv2rgb(hsva.xyz),hsva.a);
}
vec4 hsv2rgba(vec3 hsv) {
	return vec4(hsv2rgb(hsv),1.);
}
vec4 hsv2rgba(float h, float s, float v) {
	return hsv2rgba(vec3(h,s,v));
}
vec4 hsv2rgba(float h) {
	return hsv2rgba(h, 1., 1.);
}

`

header += `float random (vec2 seed);`
glsl += `
// https://thebookofshaders.com/10/
float random (vec2 seed) {
	return fract(sin(dot(seed.xy,vec2(12.9898,78.233)))*43758.5453123);
}
`

header += `float sigmoid(float x, float k);float sigmoidLin(float x, float k);vec2 sigmoid(vec2 x, float k);vec3 sigmoid(vec3 x, float k);vec4 sigmoid(vec4 x, float k);vec2 sigmoid(vec2 x, vec2 k);vec3 sigmoid(vec3 x, vec3 k);vec4 sigmoid(vec4 x, vec4 k);`
glsl += `float sigmoid(float x, float k) { return 1./(1.+exp( -(x - k*k)/k )); }
float sigmoidLin(float x, float k) { return x*sigmoid(x,k); }

vec2 sigmoid(vec2 x, float k) { return vec2(sigmoid(x.x,k),sigmoid(x.y,k)); }
vec3 sigmoid(vec3 x, float k) { return vec3(sigmoid(x.x,k),sigmoid(x.y,k),sigmoid(x.z,k)); }
vec4 sigmoid(vec4 x, float k) { return vec4(sigmoid(x.x,k),sigmoid(x.y,k),sigmoid(x.z,k),sigmoid(x.w,k)); }
vec2 sigmoid(vec2 x, vec2 k) { return vec2(sigmoid(x.x,k.x),sigmoid(x.y,k.y)); }
vec3 sigmoid(vec3 x, vec3 k) { return vec3(sigmoid(x.x,k.x),sigmoid(x.y,k.y),sigmoid(x.z,k.z)); }
vec4 sigmoid(vec4 x, vec4 k) { return vec4(sigmoid(x.x,k.x),sigmoid(x.y,k.y),sigmoid(x.z,k.z),sigmoid(x.w,k.w)); }
`
